import t from"../mixins/gaEvents.js";var e={mixins:[t],props:{title:{type:String,required:!0},lazy:{type:Boolean,default:!1}},data:()=>({active:!0})};export{e as default};
